module.exports = __webpack_public_path__ + "media/images/kreawi_logo_lila-9ac19a71b8fe44f9d97445eaccb350f1.png";